export function isPublicOption(option) {
  return option.corporate
}
